// Noise thrown by the script Chrome and the Google app inject into pages on iOS: frames are only the
// page HTML or native code, never our bundle. Sentry's inbound filters aren't available on our plan,
// so the SDK drops these before sending. Keep the patterns anchored so real errors (e.g. React error 185,
// "Maximum update depth exceeded") still report.
// https://linear.app/krea/issue/KREA-4636
export const SENTRY_IGNORE_ERRORS: (string | RegExp)[] = [
  // "Error: pa", "Error: La", "Error: Aa", ... and "Error: Ka`prod"
  /^Error: [A-Za-z]a(`\w+)?$/,
  // WebKit spelling, with the trailing period
  /^RangeError: Maximum call stack size exceeded\.?$/,
];

const THIRD_PARTY_SCRIPT_HOSTS = [
  "googletagmanager",
  "analytics.google.com",
  "clarity.ms",
];

export const isThirdPartyScriptFrame = (filename?: string): boolean =>
  THIRD_PARTY_SCRIPT_HOSTS.some((host) => filename?.includes(host) ?? false);
